import { Component, OnInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Church } from '../../../../models/church.model';
import { ChurchService } from '../../../../services/church/church.service';

@Component({
  selector: 'app-buscar-iglesia',
  templateUrl: './buscar-iglesia.component.html',
  styleUrls: ['./buscar-iglesia.component.css']
})
export class BuscarIglesiaComponent implements OnDestroy {
  termino: string;
  iglesias: Church[] = [];

  navigationSubscription:any;
  suscripcion:any;

  constructor(private _iglesiasService: ChurchService,
    private router: Router) {

    this.navigationSubscription = this.router.events;
    
    this.suscripcion = this.navigationSubscription.subscribe((e: any)=>{
      if(e instanceof NavigationEnd)
      {
        this.initialiseInvites();
      }
    })


  }

  initialiseInvites()
  {
    this.buscarIglesias();
  }

  ngOnDestroy()
  {
    this.suscripcion.unsubscribe();
  }

  buscarIglesias()
  {
    console.log("Ejecutando buscar iglesia " + this._iglesiasService.terminoBuscar);
    this._iglesiasService.getIglesiasByTermino()
      .then((data) => {
        this.iglesias = data;
        this.termino = this._iglesiasService.terminoBuscar;
        this._iglesiasService.terminoBuscar = '';
      })
      .catch((error) => {
        console.error("Hubo un error");
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/buscar-iglesia/buscar-iglesia.component.ts